export default "__VITE_ASSET__B5VmvQ9R__"